import React from "react";
import { Link } from "react-router-dom";
import { CATEGORY_META, currency } from "@/lib/constants";
import { MapPin, TrendingUp } from "lucide-react";

export default function OpportunityCard({ opp, variant = "default" }) {
  const meta = CATEGORY_META[opp.category] || {};
  const score = Math.round(opp.ai_score?.opportunity || 0);
  const risk = opp.ai_score?.risk_level || "medium";
  const riskColor = { low: "#34d399", medium: "#fbbf24", high: "#f87171" }[risk];

  return (
    <Link
      to={`/app/opportunities/detail/${opp.id}`}
      data-testid={`opp-card-${opp.id}`}
      className="group block bg-[#1c1712] border border-[#33291f] rounded-lg overflow-hidden hover:border-[#d4a574]/40 hover:-translate-y-0.5 [transition:transform_200ms_ease,border-color_200ms_ease]"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-[#241d16]">
        {opp.image_url && (
          <img src={opp.image_url} alt="" className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 [transition:transform_600ms_ease,opacity_300ms_ease]" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#14100c] via-transparent to-transparent" />
        <div className="absolute top-2.5 left-2.5 flex items-center gap-1.5 px-2 py-1 rounded bg-[#14100c]/90 border border-[#33291f] text-[10px] uppercase tracking-wider font-semibold" style={{ color: meta.color }}>
          <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: meta.color, boxShadow: `0 0 8px ${meta.color}` }} />
          {meta.label}
        </div>
        <div className="absolute top-2.5 right-2.5 glass rounded px-2 py-1 flex items-center gap-1">
          <TrendingUp size={11} className="text-[#d4a574]" />
          <span className="font-mono text-[12px] font-semibold">{score}</span>
          <span className="text-[9px] text-[#7a6d5a] uppercase tracking-wider">AI</span>
        </div>
      </div>
      <div className="p-3.5">
        <div className="font-display text-[15px] font-semibold leading-tight line-clamp-2 mb-1.5">{opp.title}</div>
        <div className="flex items-center gap-1.5 text-[11px] text-[#7a6d5a] mb-3">
          <MapPin size={11} />
          <span className="truncate">{opp.city}, {opp.state}</span>
          {opp.building_size_sqft && <span className="font-mono">· {opp.building_size_sqft.toLocaleString()} sqft</span>}
        </div>
        <div className="flex items-center justify-between pt-2.5 border-t border-[#33291f]">
          <div>
            <div className="text-[9px] uppercase tracking-wider text-[#7a6d5a]">Est. Price</div>
            <div className="font-mono text-[14px] text-[#d4a574] font-semibold">{currency(opp.price)}</div>
          </div>
          <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider" style={{ color: riskColor }}>
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: riskColor }} />
            {risk} risk
          </div>
        </div>
      </div>
    </Link>
  );
}
